import { Card } from '@ics-portal/guardian';
import { type ReactNode } from 'react';
import type { Scalars } from '@gql/graphql';
import { getProjectPath, ProjectPath } from '@utils/getMenuContent';
import { useSummaryCards } from '@pages/project/summary/_utils/contexts/SummaryCardsContext';
import s from './SummaryCards.module.scss';
import { SummaryCardContent } from './components/SummaryCardContent';
import { SummaryCardTitle } from './components/SummaryCardTitle';

interface Props {
    pid: Scalars['ID']['input'];
}

export default function SecurityZonesCard({ pid }: Props): ReactNode {
    const { data } = useSummaryCards();
    const zones = data?.projectZonesCount ?? null;

    return (
        <Card
            title={
                <SummaryCardTitle
                    icon="network_locked"
                    title="Security zones"
                    iconClassName={s.securityZoneIcon}
                />
            }
            cardClassName={s.card}
            foldable={false}
        >
            <SummaryCardContent
                footer={<h2 className="text-white">{zones}</h2>}
                to={getProjectPath(ProjectPath.Assets, pid)}
            />
        </Card>
    );
}
